import React, { useContext } from 'react';

import { REMOVED_SONG_NAME } from '@/config/constants';
import { useLayout } from '@/providers/LayoutProvider';
import { LimitedTeamSong, useTeamSongs } from '@/providers/TeamSongsProvider';

import { LayoutContext } from '../Layout';
import { SongCard, SongCardProps } from '../shared/SongCard';

type TeamSongCardProps = Omit<SongCardProps, 'song' | 'onClick'> & {
	teamSongId?: string;
	skipRemoved?: boolean;
	isModalViewOnly?: boolean;
	onClick?: (song: LimitedTeamSong) => void;
};

export const TeamSongCard: React.FC<TeamSongCardProps> = ({
	teamSongId,
	skipRemoved,
	isModalViewOnly = false,
	onClick,
	...songCardProps
}) => {
	const { findTeamSongsById, isLoading } = useTeamSongs();
	const teamSong = findTeamSongsById([teamSongId])[0];
	const { openSong } = useLayout();

	if (!teamSong) {
		return skipRemoved ? null : (
			<SongCard
				song={{
					artist: '-',
					name: REMOVED_SONG_NAME,
					recordedKey: '-',
				}}
				removed
			/>
		);
	}

	return (
		<SongCard
			onClick={() => {
				openSong({ teamSongId: teamSongId, viewOnly: isModalViewOnly });
				if (onClick) {
					onClick(teamSong);
				}
			}}
			isLoading={isLoading}
			song={teamSong}
			{...songCardProps}
		/>
	);
};
